import { FunctionComponent } from 'react';
import Program from 'wwg-utilities/dist/collections/program';
import supportMeritsIconMapping from '../../../lib/config/project/supporMerits';
import CircleIcon from '../../icons/Circle';

interface SupportMeritsProps {
    program: Program;
}

const SupportMerits: FunctionComponent<SupportMeritsProps> = ({
    program,
}) => {
    let supportMerits = program.supportMerits as string[];
    return (
        <>
            <section className="flex flex-wrap my-4">
                {supportMerits && supportMerits.length ? (
                    supportMerits.map((merit: string, index: number) => {
                        return (
                            <div key={`supportMerit-${index}`} className="flex items-center m-2">
                                <CircleIcon
                                    icon={(supportMeritsIconMapping as any)[merit]}
                                    className="p-2 bg-requirements"
                                />
                                <p className="text-xs md:text-sm xl:text-base">
                                    &nbsp;&nbsp;&nbsp;{merit}
                                </p>
                            </div>
                        );
                    })
                ) : (
                    <p className="font-light text-black">
                        This program might offer help like career guidance, mentorship, or
                        other perks that help you succeed during and after participating. To
                        learn more, ask about what support services they offer if you decide
                        to reach out to them!
                    </p>
                )}
            </section>
        </>
    );
};

export default SupportMerits;
